import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import { ChatsTableDefinitionZod } from '../tables';

// Visibility from context.user only — catch-up via event-chain invalidation, not a position gate.
type Arguments = Record<string, never>;

// applicantName: live join on Applicants by phone (not a Chats column); null for BSUID / no match.
// partnerName: live join on the linked Partners; null when the chat has no named partner.
// phoneNumberUnavailable: live join on WabaUnavailablePhoneNumbers by phoneNumberId.
// visibleLoanRequestIds: loanRequestIds narrowed to the caller's visible leads, link order kept.
export const schemaChatResolver_GetChats = z.array(
    ChatsTableDefinitionZod.extend({
        applicantName: z.string().nullable(),
        // Default on FE parse — old rows lack partnerIds.
        partnerIds: z.array(schemaId).default([]),
        partnerName: z.string().nullable(),
        // Default on FE parse — older backends omit it.
        phoneNumberUnavailable: z.boolean().default(false),
        visibleLoanRequestIds: ChatsTableDefinitionZod.shape.loanRequestIds,
    }),
);

export type SchemaChatResolver_GetChats = z.infer<typeof schemaChatResolver_GetChats>;

// Backend resolver returns raw (unparsed) store rows — partnerIds stays optional pre-parse.
export type ChatResolver_GetChats = Resolver<Arguments, z.input<typeof schemaChatResolver_GetChats>>;
